<template>
	<Modal
		v-if="shown"
		:title="''"
		@close="show(false)"
		:close-on-click-outside="false"
		:width="500"
	>
		<template v-slot:body>
			<div class="text_left">
				<p class="text_block margin_bottom" v-html="$t('debtorManagement.optionAfterAddDebtor')"/>

				<div v-for="option in options" >
					<md-radio
						style="margin-bottom: 0;"
						:key="option.value"
						v-model="selectedOption"
						:value="option.value"
					>
						{{ option.label }}
					</md-radio>
				</div>

				<div class="flex flex_end">
					<md-button @click="onContinue" class="md-primary">
						{{$t("common.button.continue")}}
					</md-button>
				</div>
			</div>
		</template>
	</Modal>
</template>

<script>
import Modal from "@/components/templates/modal/Modal";
import {navigationUtils} from "@/common/navigation/navigationUtils";
import {navigationPaths} from "@/common/navigation/navigationPaths";
import {localization} from "@/common/lang/localization";
import {navigationTabs} from "@/common/navigation/navigationTabs";

const OptionAfterAddDebtor = {
	ToMarketSounding: {
		value: "toMarketSounding",
		label: localization.i18n.t("debtorManagement.optionAfterAddDebtor.toMarketSounding"),
	},
	ToSellReceivables: {
		value: "toSellReceivables",
		label: localization.i18n.t("debtorManagement.optionAfterAddDebtor.toSellReceivables"),
	},
	StayInDebtorManagement: {
		value: "stayInDebtorManagement",
		label: localization.i18n.t("debtorManagement.optionAfterAddDebtor.stayInDebtorManagement"),
	},
};

export default {
	name: "OptionsAfterAddDebtorModal",
	components: {
		Modal
	},
	data() {
		return {
			OptionAfterAddDebtor,
			shown: false,
			selectedOption: OptionAfterAddDebtor.ToMarketSounding.value,
		};
	},
	computed: {
		options() {
			return Object.values(this.OptionAfterAddDebtor);
		}
	},
	methods: {
		show(value) {
			this.shown = value;
			if (value) {
				this.selectedOption = this.OptionAfterAddDebtor.ToMarketSounding.value;
			}
		},
		onContinue() {
			this.show(false);

			if (this.selectedOption === this.OptionAfterAddDebtor.ToMarketSounding.value) {
				this.$router.push(navigationUtils.getRouteWithActiveTab(navigationPaths.seller.marketSounding, navigationTabs.seller.marketSounding.start));
				return;
			}

			if (this.selectedOption === this.OptionAfterAddDebtor.ToSellReceivables.value) {
				this.$router.push(navigationUtils.getRouteWithActiveTab(navigationPaths.seller.sell, navigationTabs.seller.sell.upload));
			}
		}
	}
};
</script>
